import React from 'react';
import PropTypes from 'prop-types';
import { ClipboardButton, Toast, } from '@payit/cool-web-ui-library';
import HtmlUtils from '../../modules/HtmlUtils';

class Label extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { label, data, stacked, } = this.props;
    return (
      <div className={`${stacked ? '' : 'row'}`} style={{ paddingBottom: '5px', }}>
        <span className="col">{`${label.display}:`}</span>
        <div className="col">
          <div className="col">
            {HtmlUtils.toHtmlText(data.display)}
          </div>
        </div>
        <div>
          <Toast />
          <ClipboardButton stringToCopy={HtmlUtils.toHtmlText(data.display)} />
        </div>
      </div>
    );
  }
}

Label.defaultProps = {
  stacked: false,
};

Label.propTypes = {
  label: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  stacked: PropTypes.bool,
};

export default Label;
